import { type SignupPlansResponse } from '@/features/account/services/MembershipPlan/types'
import { couponCodeQueryOptions } from '@/features/authentication/services/SignupPromotions/queries'
import { getQueryClient } from '@/features/shared/utils/dataFetching/reactQuery/SegwayQueryClient'
import { logError } from '@/features/shared/utils/logger'
import { signupPlansQueryOptions } from '@/features/shop/services/DeliveryPlans/queries'
import { isAxiosError } from 'axios'
import { type ParsedUrlQuery } from 'node:querystring'

export const getHasSignupPromotionPlans = (signupPromo?: SignupPlansResponse) => {
  const defaultPromotionIds = process.env.NEXT_PUBLIC_DEFAULT_SIGNUP_PROMOTION_IDS.split(',')
  return (
    signupPromo?.signup_plans?.some(
      (plan) =>
        plan.signup_promotion_id &&
        !defaultPromotionIds.find(
          (defaultPromotionId) => plan.signup_promotion_id === Number(defaultPromotionId),
        ),
    ) ?? false
  )
}

export const validateCouponCode = async (giftCode: string) => {
  try {
    const response = await getQueryClient().query(couponCodeQueryOptions({ gift_code: giftCode }))
    return Boolean(response.code)
  } catch {
    // We want to return true for a falsy gift_code so that we can take them to correct page to show errors.
    return true
  }
}

export const checkHasValidPromotion = async ({
  email,
  queryParams,
}: {
  email: string
  queryParams: ParsedUrlQuery
}) => {
  try {
    const { param = '', referrerUrl = '', zip = '', zipcode = '' } = queryParams
    const signupPlans = await getQueryClient().query(
      signupPlansQueryOptions({
        email,
        zip_code: String(zip || zipcode),
        param: String(param),
        referring_url: String(referrerUrl),
      }),
    )
    return getHasSignupPromotionPlans(signupPlans)
  } catch (e) {
    if (!isAxiosError(e)) {
      logError(e)
    }
    return false
  }
}

export const checkForSignupOffer = ({
  email,
  queryParams,
}: {
  email: string
  queryParams: ParsedUrlQuery
}) => {
  const { gift_code } = queryParams
  if (typeof gift_code === 'string' && gift_code) {
    return validateCouponCode(gift_code)
  }
  return checkHasValidPromotion({ email, queryParams })
}
